/** Mirrors PartnerAuditLogResource in kashround-api. */
export interface AuditLogActor {
  uuid: string;
  name: string;
  role: string;
}

export interface AuditLogEntry {
  id: number;
  event: string;
  auditableType: string;
  auditableId: number | null;
  description: string;
  oldValues: Record<string, unknown> | null;
  newValues: Record<string, unknown> | null;
  ipAddress: string | null;
  createdAt: string;
  /** null for a failed sign-in by an email matching no partner. */
  actor: AuditLogActor | null;
}

export interface AuditLogMeta {
  total: number;
  currentPage: number;
  lastPage: number;
  perPage: number;
  /**
   * Both filter lists come from the API. Hardcoding event names here is what
   * the spec's phases 1 and 2 lesson warns against: a hand-written list of
   * plausible-sounding backend values drifts silently.
   */
  events: string[];
  actors: { uuid: string; name: string }[];
}

/**
 * "partner.login_failed" reads as "Login failed". Derived, not a lookup table,
 * so a new backend event needs no frontend change to render properly.
 */
export function humaniseEvent(event: string): string {
  const tail = event.includes('.') ? event.slice(event.indexOf('.') + 1) : event;
  const words = tail.replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}
